import React, { FC } from 'react';
import { SidebarLayoutProps } from './SidebarLayoutProps';
import Stack from '@mui/material/Stack';
import SidebarDrawerIcon from '../SidebarDrawerIcon';

const SidebarLayout: FC<SidebarLayoutProps> = ({
  mainItem,
  secondaryItem,
  drawerOpen,
  setDrawerOpen,
}) => {
  return (
    <Stack
      width={drawerOpen ? '30%' : 40}
      maxWidth={400}
      direction="column"
      spacing={3}
      pt={3}
      pl={3}
    >
      <Stack direction="column" spacing={3} zIndex={1}>
        {mainItem()}
      </Stack>
      {secondaryItem && secondaryItem()}
      <SidebarDrawerIcon drawerOpen={drawerOpen} clickHandler={setDrawerOpen} />
    </Stack>
  );
};

export default SidebarLayout;
